module.exports = __webpack_public_path__ + "static/img/12-4new1.659e3f3.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/english/12-4new1.png
// module id = CRbV
// module chunks = 15